// ADDED
import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const dtrCorrectionService = {
  getByEmployee: async (employeeId) => {
    return await axios.get(`${domain}/api/ChangeLogRequest/employee/${employeeId}`, { headers });
  },

  getApproverHierarchy: async (employeeId) => {
    return await axios.get(`${domain}/api/ApproverHierarchy/${employeeId}`, { headers });
  },

  getEmployeeBasicInfo: async (employeeId) => {
    return await axios.get(`${domain}/api/Employee/${employeeId}`, { headers });
  },

  getAllActiveEmployees: async () => {
    return await axios.get(`${domain}/api/Employee/basic-info/all/active`, { headers });
  },

  create: async (payload) => {
    return await axios.post(`${domain}/api/ChangeLogRequest`, payload, { headers });
  },

  createApproval: async (payload) => {
    return await axios.post(`${domain}/api/Approval/0`, payload, { headers });
  },

  sendSms: async (smsData) => {
    // External SMS Service
    return await axios.post('http://161.49.93.114:8081/api/Sms/send-sms', smsData);
  }
};

export default dtrCorrectionService;